import { EventEmitter, Injectable, Output } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from  "../../../../src/environments/environment";
import { catchError, retry  } from "rxjs/operators";
import { throwError, Observable } from "rxjs";
import { LogService } from "../../services/common/log.service";

let count = 0;

@Injectable({
  providedIn: "root",
})

export class ButlerService {
  deepLinkId: string  = "";
  oemId: string= "";
  appId: string= "";
  userId: string= "";
  deviceId: string= "";
  apiKey: string= "";
  ueiRc: string= "";
  iotQuicksetId: string= "";
  brand: string= "";
  brandName: string= "";
  ipAddress: string= "";
  instruction: string= "";
  supportedBrands:any;
  token: Observable<Object> | undefined;

  constructor(private httpClient: HttpClient, private logService: LogService) {}

  @Output() loadAddDevicePageeventEmitter: EventEmitter<any> =
    new EventEmitter();

  public loadAddDevicePage =(): void => {
    this.loadAddDevicePageeventEmitter.emit();
  }

  public getLoadAddDevicePageeventEmitterValue=()=> {
    return this.loadAddDevicePageeventEmitter;
  }

  public addDevice =(
    masterId: string,
    userId: null,
    conversationId: string,
    deviceId: string,
    brand: any,
    model: null,
    deviceType: any,
    deviceGuid: any,
    deviceAddress: null,
    macAddress: null,
    extraData: null,
    formatVersion: number
  ) => {
    return this.httpClient.post<any>(
      `${environment.nevoAIButlerAPIEndpoint}/api/Butler/AddDevice`,
      {
        masterId: masterId,
        userId: userId,
        conversationId: conversationId,
        deviceId: deviceId,
        brand: brand,
        model: model,
        deviceType: deviceType,
        deviceGuid: deviceGuid,
        deviceAddress: deviceAddress,
        macAddress: macAddress,
        extraData: extraData,
        formatVersion: formatVersion,
      },
      {
        headers: new HttpHeaders({
          Accept: "application/json",
          "Content-Type": "application/json",
          UeiRc: this.ueiRc,
        }),
      }
    );
  }

  public deleteDeepLink= (id: string) =>{
    return this.httpClient.delete(
      `${environment.deepLinksApiUrl}/api/DeepLinks/${id}/corsdeeplink`,
      {
        headers: new HttpHeaders({
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    );
  }

  public getDeepLink = (id: string) => {
    let deepLinkResponse : any = this.httpClient
      .get(`${environment.deepLinksApiUrl}/api/DeepLinks/${id}/corsdeeplink`, {
        headers: new HttpHeaders({
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        observe: "response",
      })
      .pipe(
        retry({count: 2, delay: 2500}),
        catchError(this.handleError)
      );
    return deepLinkResponse;
  }

  private handleError(err: HttpErrorResponse) {
    this.logService.logWarning(
      `butler.service - getDeepLink() - retryWhen - retry attempt #${count} - error = ${JSON.stringify(
        err
      )}`
    );
    return throwError(() => err);
  }

  public remote =(
    id: string,
    formatVersion: number,
    deviceId: string,
    userId: null,
    conversationId: string,
    notifications: any[],
    actions: { actionType: string; actionID: number; functionId: null; actionScript: string; actionResult: null; synchronous: boolean; }[]
  ) => {
    const headers = this.apiKey
      ? new HttpHeaders({
          apiKey: `D+${this.iotQuicksetId}+${this.apiKey}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        })
      : new HttpHeaders({
          ueiRc: this.ueiRc,
          Accept: "application/json",
          "Content-Type": "application/json",
        });

    return this.httpClient.post(
      `${environment.nevoAIButlerAPIEndpoint}/api/Butler/Remote`,
      {
        id: id,
        formatVersion: formatVersion,
        deviceId: deviceId,
        userId: userId,
        conversationId: conversationId,
        notifications: notifications,
        actions: actions,
      },
      {
        headers: headers,
      }
    );
  }
}

